// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected[data-v-3e565966]{opacity:1}.noSelected[data-v-3e565966]{opacity:.57}div[data-v-3e565966]{height:100%}.divNameObjetivo[data-v-3e565966]{font-family:DINPro;font-size:14px;font-weight:700;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:.2px;color:#4c4c4c}", ""]);
// Exports
module.exports = exports;
